module.exports = __webpack_public_path__ + "img/order3.dc392fa4.png";